import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

export default function NotificationSettings() {
  const { theme } = useTheme();
  const [settings, setSettings] = useState({
    posts: {
      email: true,
      push: true,
      inApp: true
    },
    comments: {
      email: true,
      push: true,
      inApp: true
    },
    mentions: {
      email: true,
      push: true,
      inApp: true
    },
    follows: {
      email: false,
      push: true,
      inApp: true
    },
    messages: {
      email: true,
      push: true,
      inApp: true
    },
    marketing: {
      email: false,
      push: false,
      inApp: true
    }
  });

  const handleToggle = (category: string, type: string) => {
    setSettings(prev => ({
      ...prev,
      [category]: {
        ...prev[category as keyof typeof prev],
        [type]: !prev[category as keyof typeof prev][type as keyof typeof prev[keyof typeof prev]]
      }
    }));
  };

  const notifications = [
    {
      category: 'posts',
      label: 'New Posts',
      description: 'When people you follow create new posts'
    },
    {
      category: 'comments',
      label: 'Comments',
      description: 'When someone comments on your posts'
    },
    {
      category: 'mentions',
      label: 'Mentions',
      description: 'When someone mentions you in a post or comment'
    },
    {
      category: 'follows',
      label: 'New Followers',
      description: 'When someone follows you'
    },
    {
      category: 'messages',
      label: 'Direct Messages',
      description: 'When you receive a direct message'
    },
    {
      category: 'marketing',
      label: 'Marketing',
      description: 'Updates about new features and promotions'
    }
  ];

  return (
    <div className="space-y-6">
      <div className={`
        overflow-x-auto
        ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'}
        rounded-lg
      `}>
        <table className="w-full">
          <thead>
            <tr className={theme === 'dark' ? 'border-b border-gray-700' : 'border-b'}>
              <th className={`
                px-6 py-4 text-left text-sm font-medium
                ${theme === 'dark' ? 'text-gray-200' : 'text-gray-700'}
              `}>
                Notification Type
              </th>
              <th className={`
                px-6 py-4 text-center text-sm font-medium
                ${theme === 'dark' ? 'text-gray-200' : 'text-gray-700'}
              `}>
                Email
              </th>
              <th className={`
                px-6 py-4 text-center text-sm font-medium
                ${theme === 'dark' ? 'text-gray-200' : 'text-gray-700'}
              `}>
                Push
              </th>
              <th className={`
                px-6 py-4 text-center text-sm font-medium
                ${theme === 'dark' ? 'text-gray-200' : 'text-gray-700'}
              `}>
                In-App
              </th>
            </tr>
          </thead>
          <tbody>
            {notifications.map((notification) => (
              <tr
                key={notification.category}
                className={theme === 'dark' ? 'border-b border-gray-700' : 'border-b'}
              >
                <td className="px-6 py-4">
                  <div>
                    <p className={`font-medium ${
                      theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
                    }`}>
                      {notification.label}
                    </p>
                    <p className={`text-sm ${
                      theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
                    }`}>
                      {notification.description}
                    </p>
                  </div>
                </td>
                {['email', 'push', 'inApp'].map((type) => (
                  <td key={type} className="px-6 py-4">
                    <div className="flex justify-center">
                      <button
                        onClick={() => handleToggle(notification.category, type)}
                        className={`
                          relative inline-flex h-6 w-11 items-center rounded-full
                          transition-colors duration-200 ease-in-out focus:outline-none
                          ${settings[notification.category as keyof typeof settings][type as keyof typeof settings[keyof typeof settings]]
                            ? 'bg-blue-600'
                            : theme === 'dark'
                              ? 'bg-gray-700'
                              : 'bg-gray-200'
                          }
                        `}
                      >
                        <span
                          className={`
                            inline-block h-4 w-4 transform rounded-full bg-white shadow
                            transition-transform duration-200 ease-in-out
                            ${settings[notification.category as keyof typeof settings][type as keyof typeof settings[keyof typeof settings]]
                              ? 'translate-x-6'
                              : 'translate-x-1'
                            }
                          `}
                        />
                      </button>
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end space-x-4">
        <button
          className={`
            px-4 py-2 rounded-lg transition-colors
            ${theme === 'dark'
              ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }
          `}
        >
          Reset to Default
        </button>
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
}